export const PRODUCT_SECTION_CONFIG = {
  restaurant: {
    show: {
      nutrition: true,
      options: true,
      addons: true,
      pharmacyInfo: false,
    },
    requiredFields: [
      'product.name',
      'prices.price',
      'productOptions',
    ],
  },

  regular_store: {
    show: {
      nutrition: true,
      options: true,
      addons: false,
      pharmacyInfo: false,
    },
    requiredFields: [
      'product.name',
      'prices.price',
      'availability.stock_quantity',
    ],
  },

  pharmacy: {
    show: {
      nutrition: false,
      options: false,
      addons: true,
      pharmacyInfo: true,
    },
    requiredFields: [
      'product.name',
      'pharmacyInfo',
    ],
  },
}